import axios from "axios";

export function updateAccounts(data, accountId) {
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/accounts`,
    data: data
  };
  return axios(config);
}

export function updateBusiness(data, accountId) {
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/business`,
    data: data
  };
  return axios(config);
}

export function updateBusinessInfo(data, accountId) {
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/business-info`,
    data: data
  };
  return axios(config);
}

export function updateOrderLimits(accountId, data, id) {
  console.log("accountId: ", accountId)
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/order-limits/${id}`,
    data: data
  };
  return axios(config);
}

export function updateAccountSSo(data, accountId) {
  console.log("accountId: ", accountId)
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/account-sso`,
    data: data
  };
  return axios(config);
}

export function updateLargeOrder(data, accountId) {
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/large-order`,
    data: data
  };
  return axios(config);
}